import { sendReadStateDB } from '@/scripts/dataBase';
import type {
  ChatGroupReadStateId,
  ChatGroupReadStateParams,
  ChatGroupReadStateReaderArgParams,
  DBChatGroupReadState,
} from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import { ActionType } from '@/scripts/dataBase/type';

const DBApis = {
  getReadStateByMessageId(message_id: ChatGroupReadStateId) {
    return sendReadStateDB<DBChatGroupReadState[]>(ActionType.queryReadStateByMsgId, {
      params: message_id,
    }).then((res) => res[0]);
  },
  async insertReadStates(args: ChatGroupReadStateParams[]) {
    await sendReadStateDB(ActionType.addOrUpdateReadstates, {
      params: args,
    });
    return args;
  },
  removeReadState(ids: ChatGroupReadStateId[]) {
    return sendReadStateDB(ActionType.deleteReadStates, {
      params: ids,
    });
  },
};

export const readStatusApis = {
  getReadStateByMessageId(message_id: ChatGroupReadStateId) {
    return DBApis.getReadStateByMessageId(message_id) as Promise<DBChatGroupReadState>;
  },
  async insertReadState(args: ChatGroupReadStateParams[]) {
    await DBApis.insertReadStates(args);
    return Promise.all(
      args.map((item) => DBApis.getReadStateByMessageId(item.message_id))
    );
  },
  removeReadState(ids: ChatGroupReadStateId[]) {
    return DBApis.removeReadState(ids);
  },
  async insertReadStateReader(list: ChatGroupReadStateReaderArgParams[]) {
    const items: ChatGroupReadStateParams[] = [];
    list.map(({ message_id, args }) => {
      const data = {
        message_id,
        reader_ids: JSON.stringify(
          args.reduce(
            (acc, userId) => {
              acc[userId] = 1;
              return acc;
            },
            {} as Record<string, 1>
          )
        ),
        // Expire read status record
        // expire_at: serverTime.time + defaultMsgExpireDuration, // TODO amo: Auto Expire
      };

      items.push(data);
    });
    await this.insertReadState(items);
  },
};
